/** Подпись поля цены из 1С (WH-001) */
export const PRICE_COST_WITHOUT_VAT = 'Себестоимость без НДС';
export const PRICE_COST_WITHOUT_VAT_RUB = 'Себестоимость без НДС, руб';
export const PRICE_RECOMMENDED_RETAIL = 'Рекомендованная розница';
export const PRICE_RECOMMENDED_RETAIL_RUB = 'Рекомендованная розница, руб';
